import React from 'react';
import {Helmet} from 'react-helmet-async';


const SeoComp = ({title, image,description}) => {
    return <Helmet>
        <title>{title}</title>
        <meta property="og:title" content={title} />
        <meta property="og:image" content={image} />
        <meta property="og:description" content={description} />
        <meta name="description" content={description} />
    </Helmet>
}

export default SeoComp;